/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  settings: 'Inställningar',
  setting: 'Inställning',
  defaultLocale: 'Standardspråk',
  mail: 'E-post',
  driver: 'Anslutning',
  host: 'Server',
  port: 'Port',
  username: 'Användarnamn',
  password: 'Lösenord',
  encryption: 'Kryptering',
  fromAddress: 'Från-adress',
  fromName: 'Från-namn',
  save: 'Spara',
  saveSuccess: 'Inställningarna har sparats.',
  saveFailure: 'Inställningarna kunde inte sparas.',
  fetchFailure: 'Inställningarna kunde inte hämtas.',
  updates: 'Uppdateringar',
  update: 'Uppdatera',
  newUpdatesAvailable: 'Det finns nya uppdateringar att hämta.',
  beforeUpdatingMakeSure: 'Innan uppdatering utförs, se till så att installationsmappen är skrivbar för PHP-processen. Om uppdateringen avslutas med ett fel, så behöver du köra "php artisan refresh" manuellt från terminalprompten för att slutföra uppdateringen.',
}
